module.exports = __webpack_public_path__ + "img/icon_Space_G.426c1744.svg";